import React, { useEffect, useState, useRef } from 'react'
import { Store } from 'react-notifications-component'

const ApiStatusNotification: React.FC = () => {
  const [hasShownNotification, setHasShownNotification] = useState(false)
  const originalConsoleErrorRef = useRef<typeof console.error | null>(null)

  useEffect(() => {
    // Store original console.error
    originalConsoleErrorRef.current = console.error
    
    // Override console.error to catch API errors
    console.error = (...args) => {
      const message = args.join(' ')
      
      // Check for 401 Unauthorized errors
      if (message.includes('401') && message.includes('Unauthorized') && !hasShownNotification) {
        Store.addNotification({
          title: 'Authentication Required',
          message: 'Your session has expired. Please log in again.',
          type: 'warning',
          insert: 'top',
          container: 'top-right',
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        })
        setHasShownNotification(true)
      }
      
      // Check for 500 errors related to chatbot
      if (message.includes('500') && message.includes('chatbot') && !hasShownNotification) {
        Store.addNotification({
          title: 'Service Temporarily Unavailable',
          message: 'Some features may not be available due to server maintenance.',
          type: 'info',
          insert: 'top',
          container: 'top-right',
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        })
        setHasShownNotification(true)
      }
      
      // Call original console.error
      if (originalConsoleErrorRef.current) {
        originalConsoleErrorRef.current.apply(console, args)
      }
    }
    
    // Cleanup function
    return () => {
      if (originalConsoleErrorRef.current) {
        console.error = originalConsoleErrorRef.current
      }
    }
  }, [hasShownNotification])

  return null // This component doesn't render anything
}

export default ApiStatusNotification
